import React from "react";
import {useMemo} from "react";
import isEmpty from "../../../../../utils/objectchecking/IsEmpty";

export default function useDataMemo(
    top,
    optionManagement,
    viewOptionManagementEnabled,
    entryTactics,
    positionTactics,
    exitTactics,
    setupFilters,
    setupFields,
    setupDetails,
    restartSettings
) {
    const data = useMemo(() => {
        const {
            maxOptionSpreadPct,
            getAwayOffsetPct,
            pctBetweenBidAsk,
            pctIncreasePerOrderAttempt,
            quantityBasis,
            ...remaining
        } = top;
        return {
            ...(top.instrument === "option" &&
                maxOptionSpreadPct > 0 &&
                maxOptionSpreadPct <= 1 && {
                    maxOptionSpreadPct: parseFloat(maxOptionSpreadPct),
                }),

            // ...(top.instrument === "option" && { buyOrSellOption }),
            ...(top.workOrders === true && {
                getAwayOffsetPct,
                pctBetweenBidAsk,
                pctIncreasePerOrderAttempt,
            }),
            ...{quantityBasis: quantityBasis === undefined ? undefined : quantityBasis.toUpperCase()},
            ...remaining,

            ...{entryTactics: entryTactics},
            ...(!isEmpty(positionTactics) && {positionTactics}),
            ...{exitTactics: exitTactics},
            ...(!isEmpty(setupFilters) && {setupFilters}),
            ...{setupDetails: setupDetails},
            ...(viewOptionManagementEnabled && {optionManagement}),
            restartSettings
        };
    }, [
        top,
        setupDetails,
        entryTactics,
        positionTactics,
        setupFilters,
        exitTactics,
        setupFields,
        optionManagement,
        restartSettings
    ]);
    return data;
}
